import * as Yup from "yup";
import { OptionData } from "../queries/use-specialities-list";
import { PickedWeekDayTimes } from "./common";

export type ProviderGroupLocationFormType = {
  active: boolean;
  avatar?: string;
  name: string;
  contact?: string;
  locationId: string;
  specialities?: OptionData[];
  npi?: string;
  email: string;
  website?: string;
  fax: string;
  timezone: string;
  note: string;
  locationHours?: PickedWeekDayTimes;
  archive?: boolean;
  addressCheckBox?: boolean;
  departments?: Set<Department>;
  users?: Set<any>;
  physicalAddress?: Address;
  billingAddress?: Address;
  officeHours?: PickedWeekDayTimes;
};

export const PROVIDER_GROUP_LOCATION_FORM_INITIAL_VALUES = {
  active: false,
  avatar: "",
  name: "",
  contact: "",
  locationId: "",
  specialities: undefined,
  email: "",
  fax: "",
  timezone: "",
  note: "",
  locationHours: undefined,
  physicalAddress: {
    line1: "",
    line2: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
  },
  billingAddress: undefined,
  officeHours: {},
};

export const PROVIDER_GROUP_LOCATION_SCHEMA = Yup.object({
  contact: Yup.string().min(12, "Contact Number must be at least 8 digits"),
  // avatar: Yup.string(),
  name: Yup.string()
    .required()
    .matches(
      /^[a-zA-Z0-9 ]*$/,
      "Name should only contain alphabetic characters, numeric values, and spaces",
    )
    .label("Location Name"),
  // phone: Yup.string(),
  email: Yup.string()
    .email()
    .matches(/.*@.+\..+/, "Email address must be a valid Email")
    .label("Email address")
    .optional(),

  // website: Yup.string(),
  // fax: Yup.string(),
  timezone: Yup.string().required().label("Timezone"),
  // location_id: Yup.string(),
  // description: Yup.string(),
  physicalAddress: Yup.object({
    line1: Yup.string().required().label("Line1"),
    line2: Yup.string().required().label("Line2"),
    city: Yup.string().required().label("City"),
    state: Yup.string().required().label("State"),
    country: Yup.string().required().label("Country"),
    zipcode: Yup.string()
      .matches(
        /^\d{5}(-\d{4})?$/,
        "Enter a valid ZIP Code (e.g., 12345 or 12345-6789)"
      )
      .required()
      .label("ZIP Code"),
  }),
  billingAddress: Yup.object({
    zipcode: Yup.string().matches(
      /^\d{5}(-\d{4})?$/,
      "Enter a valid ZIP Code (e.g., 12345 or 12345-6789)"
    ),
  }).nullable().optional(),
  // office_hours: Yup.object(),
});

type Address = {
  line1?: string;
  line2?: string | null;
  city?: string;
  state?: string;
  country?: string;
  zipcode?: string;
};

type LocationHour = {
  dayOfWeek: string; // Could be more specific, e.g., "MONDAY" | "TUESDAY" | ...
  openingTime: string; // Format: "HH:mm"
  closingTime: string; // Format: "HH:mm"
};

export type Department = {
  uuid: string;
  deptId: string;
  name: string;
  adminId: string | null;
  locations: any | null; // Define the type based on the actual structure if known
  contact: string;
  active: boolean;
  archive: boolean;
};

export type ProviderLocation = {
  uuid: string;
  name: string;
  locationId: string;
  specialities: Record<string, string>; // Speciality ID mapped to speciality name
  contact: string;
  npi: string | null;
  timezone: string | null;
  email: string;
  fax: string | null;
  note: string | null;
  physicalAddress: Address;
  billingAddress: Address;
  locationHours: LocationHour[];
  active: boolean;
  archive: boolean;
  addressCheckBox: boolean;
  departments: Department[];
  users: any[];
  avatar: string | null;
  officeHours?: PickedWeekDayTimes;
};

